import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Card, CardBody, CardTitle, Container, Row } from "reactstrap"
import PerfectScrollbar from "react-perfect-scrollbar"
import ApplicationList from "./applicationList"
import ApplicationForm from "./ApplicationForm"
import {
  createApplications,
  updateApplications,
} from "../../appRedux/slices/application"
import { upsertAppUser } from "../../appRedux/slices/usersList"
import BrowseUser from "../../containers/CasAppUsersList/browseUsers"
import "./dashboard.css"
import "react-perfect-scrollbar/dist/css/styles.css"
import CreateAppUserForm from "../CasAppUsersList/createAppUserForm"
import { Modal } from "react-bootstrap"
import { getCurrentUser } from "../../appRedux/slices/currentUser"
import toastr from "toastr"
import { NO_PERMISSION_MESSAGE } from "../../constants/uiConstants"

const Home = props => {
  const dispatch = useDispatch()
  const [showForm, setShowForm] = useState(false)
  const [showCreateuser, setCreateUser] = useState(false)
  const [currentApp, setCurrentApp] = useState(null)
  const [showProjects, setProjects] = useState(true)
  const { currentUser } = useSelector(state => state.currentUser)
  const {
    data: { name = "", email = "", roles = [], applications = [] } = {},
  } = currentUser || {}

  let userRoles = ""

  let hasAccess = false

  applications.map(application => {
    if (application.applicationCode === "CAT") {
      hasAccess = true
    }
  })

  roles.map(role => {
    if (userRoles) {
      userRoles = `(${userRoles} | ${role.split("_")[1]})`
    } else {
      userRoles = `(${role.split("_")[1]})`
    }
  })

  const onAppEdit = appDetails => {
    setShowForm(true)
    setCurrentApp(appDetails)
  }

  const onProjects = () => {
    setProjects(true)
  }

  const onUsers = () => {
    setProjects(false)
  }

  const onFormClose = () => {
    setShowForm(false)
    setCreateUser(false)
    setCurrentApp(null)
  }

  const _onUpsert = async formData => {
    let data = {
      formData,
      query: {
        action: "create",
        //appCode: this.state.appCode,
        //userId: this.state.userData?.userUUID || ""
      },
    }
    await dispatch(upsertAppUser(data))
    onFormClose()
  }

  const _getUserUpsertForm = () => {
    return (
      <CreateAppUserForm
        onSubmit={_onUpsert}
        //appCode={this.state.appCode}
        // data={this.state.userData}
        formAction={"create"}
        //userId={this.state.userId}
        //currentUser={this.props.currentUser}
        // permissionList={this.props.permissionList}
        // roleData={this.props.rolesList}
        // agencyList={this.props.agencyList}
        onCancel={onFormClose}
      />
    )
  }

  const _modal = () => {
    return (
      <Modal
        show={showCreateuser}
        onHide={onFormClose}
        footer={null}
        fullscreen={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="modalTitle">{"App User"}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>{_getUserUpsertForm()}</Row>
        </Modal.Body>
      </Modal>
    )
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  const onFormSave = async (appData, action) => {
    const data = new FormData()
    data.append("fields", JSON.stringify(appData))
    if (action === "create") {
      const res = await dispatch(createApplications(data))
      await sleep(2000)
      await dispatch(getCurrentUser())
    } else if (action === "update") {
      await dispatch(updateApplications(data))
    }
    onFormClose()
  }

  return (
    <Container fluid>
      <div className="center_div">
        {hasAccess ? (
          <Card
            className={`shadow-lg m-auto align-self-center`}
            // onClick={() => this.props.onEditClick(data)}
            style={{
              height: "85vh",
              width: "95vw",
            }}
          >
            <CardBody>
              <CardTitle className="font-size-20">
                Welcome, {name || email || ""}{" "}
                {userRoles ? (
                  <span className="font-size-12">{userRoles}</span>
                ) : null}
              </CardTitle>
              <br />
              <div className="d-flex justify-content-between align-items-center">
                <nav className="navbar navbar-expand-sm navbar-dark font-size-20 fw-bold">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <a className="nav-link" onClick={onProjects}>
                        Projects
                      </a>
                    </li>
                    {/* <li className="nav-item">
                                <a className="nav-link" onClick={onUsers}>Users</a>
                            </li> */}
                  </ul>
                </nav>
                {/* <div className="font-size-18 font-weight-semibold">Projects</div>
                        <div className="font-size-18 font-weight-semibold">Users</div> */}
                <div>
                  <button
                    className="font-size-16 btn-light font-weight-semibold"
                    style={{ backgroundColor: "#00a3ff" }}
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      setShowForm(true)
                    }}
                  >
                    + Add Application
                  </button>
                  <button
                    className="font-size-16 btn-light font-weight-semibold"
                    style={{ backgroundColor: "#00a3ff" }}
                    onClick={e => {
                      const hasEditPermission =
                        currentUser &&
                        currentUser.data &&
                        currentUser.data.permissions &&
                        currentUser.data.permissions.includes("CREATE_USER")
                      if (!hasEditPermission) {
                        return toastr.error(NO_PERMISSION_MESSAGE)
                      }
                      e.stopPropagation()
                      e.preventDefault()
                      setCreateUser(true)
                    }}
                  >
                    Create User
                  </button>
                </div>
              </div>

              <div className="border-top border-2 mt-4 border-dark"></div>
              {showProjects ? (
                <PerfectScrollbar style={{ height: "65vh" }}>
                  <div
                    className={
                      applications && applications.length
                        ? "card-container"
                        : ""
                    }
                  >
                    {applications && applications.length ? (
                      <ApplicationList
                        currentUser={currentUser}
                        onAppEdit={onAppEdit}
                      />
                    ) : (
                      <div
                        className="text-center text-muted font_italic_bold"
                        style={{ marginTop: "35vh" }}
                      >
                        You are not authorized to access any Projects.
                      </div>
                    )}
                  </div>
                </PerfectScrollbar>
              ) : (
                <BrowseUser fetchAllUsers={true} />
              )}
            </CardBody>
          </Card>
        ) : (
          <div className="font-size-16 text-center text-muted font_italic_bold">
            You do not have Application&#39;s Permission. Please Contact JOSH
            Admin
          </div>
        )}
      </div>
      {showForm && (
        <ApplicationForm
          app={currentApp || null}
          show={showForm}
          onClose={onFormClose}
          onSave={onFormSave}
        />
      )}
      {showCreateuser && _modal()}
      {/* {showCreateuser &&
            <CreateAppUserForm
                app={currentApp || null}
                show={showCreateuser}
                onClose={onFormClose}
                onSave={onFormSave}
                // onSubmit={this._onUpsert}
                // appCode={this.state.appCode}
                // data={this.state.userData}
                // formAction={this.state.formAction}
                // userId={this.state.userId}
                // currentUser={this.props.currentUser}
                // permissionList={this.props.permissionList}
                // roleData={this.props.rolesList}
                // // agencyList={this.props.agencyList}
                // onCancel={() => this.setState({ showModal: false, userData: {} })}
            />} */}
    </Container>
  )
}

export default Home
